<template>
  <div class="layout">
    <div class="layout__header">
      <h3>My Bill Bot</h3>
    </div>
    <div class="row">
      <div class="col-xs-12 col-lg-4">
        <div class="form-field">
          <input-field type="text" v-model="form.usuario_sri" id="usuario_sri" placeholder="Usuario registrado en SRI">
            <strong>Usuario SRI</strong>
            <span v-if="errores.usuario_sri" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.usuario_sri[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-lg-4">
        <div class="form-field">
          <input-field type="password" v-model="form.contrasena" id="contraseña_sri" placeholder="Contraseña del usuario SRI">
            Contraseña SRI
            <span v-if="errores.contrasena" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.contrasena[0] }}</strong>
          </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-lg-4">
        <div class="form-field">
          <input-field type="password" v-model="form.contrasena_confirmation" id="contraseña_confirmation" placeholder="Confirmación de la contraseña">
            Confirme contraseña
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-8">
        <div class="form-field">
          <input-field stretch type="tel" v-model="form.tiempo" id="tiempo" placeholder="" v-mask="'##'">
            <span class="label-nowrap">Periodo de ejecución automática del bot (en horas)</span>
            <span v-if="errores.tiempo" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.tiempo[0] }}</strong>
          </span>
          </input-field>
        </div>
      </div>
    </div>
    <strong>
      <p><em><small>Seleccione los dias en que el bot se ejecutará</small></em></p>
    </strong>
    <div class="row">
      <div class="col-xs-12 col-md-3">
        <div class="form-field">
          <label for="lunes">
            <input type="checkbox" class="is-filled" v-model="form.lunes" id="lunes">
            <span>Lunes</span>
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-md-3">
        <div class="form-field">
          <label for="martes">
            <input type="checkbox" class="is-filled" v-model="form.martes" id="martes">
            <span>Martes</span>
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-md-3">
        <div class="form-field">
          <label for="miercoles">
            <input type="checkbox" class="is-filled" v-model="form.miercoles" id="miercoles">
            <span>Miércoles</span>
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-md-3">
        <div class="form-field">
          <label for="jueves">
            <input type="checkbox" class="is-filled" v-model="form.jueves" id="jueves">
            <span>Jueves</span>
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-md-3">
        <div class="form-field">
          <label for="viernes">
            <input type="checkbox" class="is-filled" v-model="form.viernes" id="viernes">
            <span>Viernes</span>
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-md-3">
        <div class="form-field">
          <label for="sabado">
            <input type="checkbox" class="is-filled" v-model="form.sabado" id="sabado">
            <span>Sábado</span>
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-md-3">
        <div class="form-field">
          <label for="domingo">
            <input type="checkbox" class="is-filled" v-model="form.domingo" id="domingo">
            <span>Domingo</span>
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-md-3">
        <div class="row center-xs middle-xs">
          <div class="form-inline">
            <button class="btn-info" type="button" @click="abrirInformacion"><i class="fa fa-info-circle"></i></button>
            <img :src="url + '/images/MyBillBotLogo1.png'" alt="logo" class="img-thumb">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="cerrarModal" class="btn-danger btn--text" type="button"><i class="fa fa-sign-out"></i> <span>Cerrar</span></button>
      <button @click="guardarCambios" class="btn-success" type="button"><i class="fa fa-save"></i> <span>Guardar</span></button>
    </div>
    <modal height="auto" :scrollable="true" name="informacion">
      <div class="card">
        <div class="card__content">
          <div class="card">
            <div class="card__content">
              <img :src="url + '/images/MyBillBotLogo2.png'" class="img-fill">
              <div class="row center-xs">
                <p>Es un sistema autónomo para la extracción automática de documentos electrónicos del SRI, para poder
                  visualizarlos en el sistema MyBill.</p>
                <button @click="cerrarModal2" class="btn-success" type="button"><i class="fa fa-sign-out"></i> Volver</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
export default {
    data : function () {
        return {
            form : {
                usuario_sri : null,
                contrasena : null,
                contrasena_confirmation : null,
                tiempo : 0,
                lunes : false,
                martes : false,
                miercoles : false,
                jueves : false,
                viernes : false,
                sabado : false,
                domingo : false
            },
            errores : {
                usuario_sri : null,
                contraseña : null,
                tiempo : null
            },
            url : url
        }
    },
    methods : {
        abrirInformacion : function(){
            this.$modal.show('informacion');
        },
        cerrarModal : function(){
            this.$emit('cerrarModalBot');
        },  
        cerrarModal2 : function(){
            this.$modal.hide('informacion');
        },
        guardarCambios : function(){
            let that = this;
            this.errores.usuario_sri = null;
            this.errores.contraseña_sri = null;
            this.errores.tiempo = null;
            axios.post(this.url + '/parametros/mybillbot', that.form).then(function(response) {    
                swal({
                    type: 'success',
                    title: 'Realizado',
                    text: 'Los parametros de My Bill Bot han sido actualizados.'
                });       
                that.$emit('cerrarModalBot');
            }).catch(function(error) {            
                let response = error.response;
                if (response !== null) {
                    let status = response.status;
                    if (status === 422) {
                        that.errores = response.data.errors;
                    }
                }
            });
        },
        cargarParametros : function(){            
            let that = this;
            axios.get(url + '/parametros/mybillbot/datos').then(function(response) { 
                let configuracionEmpresa = response.data.configuracionEmpresa;
                that.form.usuario_sri = configuracionEmpresa.bb_usuario_sri;
                that.form.lunes = (configuracionEmpresa.bb_periodo_lunes==1)?true:false;
                that.form.martes = (configuracionEmpresa.bb_periodo_martes==1)?true:false;
                that.form.miercoles = (configuracionEmpresa.bb_periodo_miercoles==1)?true:false;
                that.form.jueves = (configuracionEmpresa.bb_periodo_jueves==1)?true:false;
                that.form.viernes = (configuracionEmpresa.bb_periodo_viernes==1)?true:false;
                that.form.sabado = (configuracionEmpresa.bb_periodo_sabado==1)?true:false;
                that.form.domingo = (configuracionEmpresa.bb_periodo_domingo==1)?true:false;
                that.form.tiempo = configuracionEmpresa.bb_periodo_tiempo;
            }).catch(function(error) {            
                swal({
                    type: 'error',
                    title: 'Error',
                    text: 'Al cargar los datos.'
                }); 
            });
        }
    },
    watch : {
        'form.tiempo' : function(value){
            if(value != null && value != undefined && value != ''){
                if(!isNaN(parseFloat(value)))
                    if(parseFloat(value)>24)
                        this.form.tiempo = 24;
            }
            else
                this.form.tiempo = 0;
        }
    },
    mounted : function () {
        this.cargarParametros();
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/parametrizacion/ParametrosMyBillBot.vue